import { render } from "./TeamIcon.vue?vue&type=template&id=304ff4bc&scoped=true"
const script = {}

import "./TeamIcon.vue?vue&type=style&index=0&id=304ff4bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304ff4bc"]])

export default __exports__